module.exports = __webpack_public_path__ + "img/next-fill.a5ed19c3.svg";